import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/conroo-logo.png'


const _hoisted_1 = { class: "bg-[#00295b] min-h-screen flex items-center justify-center" }
const _hoisted_2 = { class: "max-w-md w-full p-8 bg-white rounded-lg shadow-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-semibold mb-4" }, "Login", -1)
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "h-2/4 w-2/4 mx-auto mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Conroo logo"
  })
], -1)
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = {
  for: "email",
  class: "block text-gray-600"
}
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = {
  for: "password",
  class: "block text-gray-600"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "bg-[#00295b] text-white py-2 px-4 rounded-full focus:outline-none focus:ring focus:ring-blue-200"
  }, " Login ")
], -1)
const _hoisted_11 = {
  key: 0,
  class: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative",
  role: "alert"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", { class: "font-bold" }, "Error!", -1)
const _hoisted_13 = { class: "block sm:inline" }

import { ref } from 'vue';
import authService from '@/service/auth-service';
import usersClient, { UserRole } from '@/service/client/users-client';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter();
const store = useStore();

const email = ref('');
const password = ref('');
const errorMessage = ref('');

const saveToStore = async (newEmail:string, roles : UserRole[], uid : string) : Promise<void> => {
  store.commit('updateUser', { email: newEmail, roles, uid });
  await store.dispatch('saveUserInfo');
};

const login = async () : Promise<void> => {
  try {
    const firebaseUser = await authService.login(email.value, password.value);
    if (!firebaseUser) {
      errorMessage.value = 'Issue with authentication';
      return;
    }
    const userData = await usersClient.getUser(firebaseUser.uid);
    await saveToStore(userData.email, userData.roles, userData.id);
    router.push('/versions');
  } catch (e) {
    console.log(e);
    errorMessage.value = 'Issue with authentication';
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        onSubmit: _withModifiers(login, ["prevent"])
      }, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, [
            _createTextVNode("Email "),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              class: "mt-1 p-2 border rounded w-full",
              required: ""
            }, null, 512), [
              [_vModelText, email.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, [
            _createTextVNode("Password "),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              id: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
              class: "mt-1 p-2 border rounded w-full",
              required: ""
            }, null, 512), [
              [_vModelText, password.value]
            ])
          ])
        ]),
        _hoisted_10
      ], 40, _hoisted_4),
      (errorMessage.value.length !==0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(errorMessage.value), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})